<script>
import { usePuzzleStore } from '@/stores/puzzleStore';
import axios from 'axios';
export default {
  name: 'searchView',
  data() {
    return {
      username: '',
      platform: 'lichess',
      onlyMissed: false,
      analysePuzzles: false,
      numberOfGames: 25,
      gameTypes: [], // array for storing selected game types
      loading: false,
      errorMessage: '',
    };
  },
  methods: {
    async searchPuzzles() {
      this.errorMessage = '';
      if (!this.username) {
        this.errorMessage = 'Please enter a valid username.';
        return;
      }
      if (this.gameTypes.length === 0) {
        this.errorMessage = 'Please select at least one game types.';
        return;
      }
      this.loading = true;
      try {
        const requestPayload = {
          username: this.username,
          platform: this.platform,
          onlyMissed: this.onlyMissed,
          analysePuzzles: this.analysePuzzles,
          numberOfGames: this.numberOfGames,
          gameTypes: this.gameTypes,
        };


        // Make POST request to FastAPI
        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/puzzles/api/search_puzzles`,
          requestPayload
        );
        // The response data should be our puzzles array
        const puzzles = response.data;

        // Log the received puzzles
        console.log('Received puzzles:', puzzles);

        const puzzleStore = usePuzzleStore();
        puzzleStore.setAnalysisData(response.data);

        puzzleStore.setShowAnalysis(this.analysePuzzles);
      
    

        this.$router.push({ name: 'chessboard' });  // Redirect to the chess board view

      } catch (error) {
        console.error('Error fetching puzzles:', error);
        // Use the error detail from FastAPI if available
        if (error.response && error.response.data && error.response.data.detail) {
          this.errorMessage = error.response.data.detail;
        } else {
          this.errorMessage = "An error occurred while fetching puzzles.";
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<template>

  <div v-if="loading" class="d-flex align-items-center justify-content-center vh-100">
    <div class="spinner-border big-spinner" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  <div v-else>

  <div class="primary-font d-flex align-items-center justify-content-center vh-100">
    <div class="container">
      <div class="row">
        <div class="col-md-10 col-lg-8 col-xl-7 mx-auto">
          <h1 class="text-center mb-5 clr-w main-title">CHESS PUZZLE FINDER</h1>
          <div class="card">
            <div class="card-header bgr-b ro">
              <div class="input-group input-group-lg">
                <label class="visually-hidden" for="usernameInput">Username:</label>
                <input
                  type="text"
                  id="usernameInput"
                  name="usernameInput"
                  class="form-control form-control-lg bgr-b rounded searchbar"
                  placeholder="Type Your Username"
                  aria-label="Type Keywords"
                  aria-describedby="basic-addon2"
                  v-model="username"
                />
                <span class="input-group-text search-icon bgr-b" id="basic-addon2">
                  <font-awesome-icon icon="search" class="clr-w" />
                </span>
              </div>
            </div>
            <div class="card-body p-4 bgr-b">
              <div class="clr-w">
                <h5 class="settings-title mb-3">SETTINGS</h5>


                <fieldset class="mb-2">
                  <legend class="form-label me-3">Platform:</legend>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="platform"
                      id="lichess"
                      value="lichess"
                      v-model="platform"
                    />
                    <label class="form-check-label" for="lichess">Lichess</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="platform"
                      id="chess.coom"
                      value="chess.com"
                      v-model="platform"
                    />
                    <label class="form-check-label" for="chess.com">Chess.com</label>
                  </div>
                </fieldset>

           
                <div class="mb-3 form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="onlyMissed"
                    v-model="onlyMissed"
                  />
                  <label class="form-check-label" for="onlyMissed">
                    Show Only Missed
                    <font-awesome-icon
                      icon="circle-info"
                      v-tooltip="'Play only puzzles where you have missed the correct sequence.'"
                      class="ms-1"
                    />
                  </label>
                </div>

                <!-- Analyse puzzles -->
                <div class="mb-3 form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="analysePuzzles"
                    v-model="analysePuzzles"
                  />
                  <label class="form-check-label" for="analysePuzzles">
                    Analyze Openings
                    <font-awesome-icon
                      icon="circle-info"
                      v-tooltip="'Evaluate games to identify your common tactical misses and provide analysis of opening mistakes, helping you determine which openings to study more.'"
                      class="ms-1"
                    />
                  </label>
                </div>

          
                <div class="mb-4">
                  <label for="numberOfGames" class="form-label">Number of Games</label>
                  <div class="d-flex w-100">
                    <div class="w-75">
                      <input
                        type="range"
                        class="num-slider w-100 custom-slider"
                        min="1"
                        max="50"
                        step="1"
                        id="numberOfGames"
                        v-model="numberOfGames"
                      />
                      <div>
                        <span class="float-start">1</span>
                        <span class="float-end">50</span>
                      </div>
                    </div>
                    <div class="w-25 ps-4">
                      <span class="form-control bgr-w br-b" id="numGames"
                        >{{ numberOfGames }}</span
                      >
                    </div>
                  </div>
                </div>

           
                <fieldset>
                  <legend class="form-label">Type of Games</legend>
                  <div
                    class="btn-group w-100 mt-1"
                    role="group"
                    aria-label="Game Type Selection"
                  >
                    <input
                      type="checkbox"
                      class="btn-check"
                      id="classical"
                      autocomplete="off"
                      :value="'classical'"
                      v-model="gameTypes"
                    />
                    <label class="btn btn-outline-custom" for="classical">Classical</label>

                    <input
                      type="checkbox"
                      class="btn-check"
                      id="rapid"
                      autocomplete="off"
                      :value="'rapid'"
                      v-model="gameTypes"
                    />
                    <label class="btn btn-outline-custom" for="rapid">Rapid</label>

                    <input
                      type="checkbox"
                      class="btn-check"
                      id="blitz"
                      autocomplete="off"
                      :value="'blitz'"
                      v-model="gameTypes"
                    />
                    <label class="btn btn-outline-custom" for="blitz">Blitz</label>

                    <input
                      type="checkbox"
                      class="btn-check"
                      id="bullet"
                      autocomplete="off"
                      :value="'bullet'"
                      v-model="gameTypes"
                    />
                    <label class="btn btn-outline-custom" for="bullet">Bullet</label>
                  </div>
                </fieldset>
              </div>
        
              <div class="d-flex align-items-center mt-4">
                <button
                  type="button"
                  class="btn btn-info clr-b bgr-p ps-3 pe-3"
                  @click="searchPuzzles"
                >
                  Search
                </button>
              </div>
            </div>
          </div>
          <div v-if="errorMessage" class="alert alert-danger mt-3 bgr-b text-center clr-w card-red">
                  {{ errorMessage }}
                </div>
        </div>
      </div>
    </div>
  </div>
 </div>
</template>

<style scoped>


.big-spinner {
  width: 5rem;         
  height: 5rem;        
  border-width: 0.5rem; 
  color: #bb86fc;      
}

.form-check-label .fa-circle-info {
  cursor: pointer;
}
.form-check-label .fa-circle-info:hover {
  color: #a075e0;
}
.ms-1 {
  margin-left: 0.25rem;
}
.ms-1 {
  margin-left: 0.25rem;
}

.form-check-input {
  background-color: #ebecd0;
}

.form-check-input:checked {
  background-color: #bb86fc; 
  border: none;
}


.btn.bgr-p {
  border: none;
}

.btn-outline-custom {
  color: #ebecd0;
  border: 1px solid #ebecd0;
  background-color: transparent;
}

.btn.btn-outline-custom:hover {
  color: #ebecd0;
  background-color: transparent;
  border-color: #ebecd0;
}

.btn-check:checked + .btn-outline-custom {
  color: #2e2e2e;
  background-color: #bb86fc;
  border-color: #bb86fc;
}

.custom-slider {
  accent-color: #bb86fc;
}

.form-control.br-b {
  color: #2e2e2e;
}

.main-title {
  font-family: 'Oswald', sans-serif;
  font-size: 5rem;
}

.card {
  border: 2px solid #bb86fc;
  box-shadow: #bb86fc 0px 0px 20px;
}
.card-red {
  border: 2px solid #fc868e;
  box-shadow: #fc868e 0px 0px 20px;
}
.search-icon {
  border: none;
}

.bgr-w {
  background-color: #ebecd0;
}
.clr-w {
  color: #ebecd0;
}

.clr-p {
  color: #bb86fc;
}

.bgr-p {
  background-color: #bb86fc;
}

.bgr-b {
  background-color: #2e2e2e;
  /*#1d1d1d or #2e2e2e*/
}

.searchbar::placeholder {
  color: #ebecd0;
  opacity: 	1;
}

.searchbar:focus {
  background-color: #2e2e2e;
}

.searchbar:focus::placeholder {
  opacity: 0;
}

.form-control.searchbar {
  background-color: #2e2e2e;
  color: #ebecd0;
}

.card-header {
  border-bottom: 3px solid #bb86fc;
}

.form-control {
  border-color: transparent;
}

.input-group>.form-control:focus {
  border-color: transparent;
  box-shadow: inset 0 0 0 1px transparent;
}
</style>
